<template>
    <v-sheet class="py-md-5" height="100%" color="transparent">
        <div class="text-center mb-5">
            <core-subheading class="mb-1" v-text="value.name" />
            <span class="subheading" v-text="value.type" />
        </div>

        <v-row>
            <v-col v-if="$vuetify.breakpoint.smAndDown">
                <v-img :src="require(`@/assets/projects/${value.img}`)" contain class="mx-auto" />
            </v-col>

            <v-col cols="md-4" offset-md="1">
                <div class="mb-3">
                    <core-subheading class="mb-3">
                        {{ $t('portfolio.description') }}
                    </core-subheading>

                    <core-text>
                        {{ value.description }}
                    </core-text>

                    <core-subheading>
                        {{ $t('portfolio.information') }}
                    </core-subheading>

                    <v-list class="transparent">
                        <v-list-item>
                            <v-list-item-action>
                                <v-icon color="primary">
                                    mdi-wrench
                                </v-icon>
                            </v-list-item-action>
                            <v-list-item-title class="mr-2" v-if="$vuetify.breakpoint.mdAndUp">
                                {{ $t('portfolio.technologies') }}
                            </v-list-item-title>
                            <v-list-item>
                                {{ value.technologies }}
                            </v-list-item>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-action>
                                <v-icon color="primary">
                                    mdi-link-variant
                                </v-icon>
                            </v-list-item-action>
                            <v-list-item-title class="mr-2" v-if="$vuetify.breakpoint.mdAndUp">
                                {{ $t('portfolio.url') }}
                            </v-list-item-title>
                            <v-list-item class="text-caption ">
                                <div class="link ">
                                    <a
                                        class="text--lighten-1"
                                        :href="'https://' + value.url"
                                        target="_blank"
                                        ><h3>{{ value.url }}</h3>
                                    </a>
                                </div>
                            </v-list-item>
                        </v-list-item>
                    </v-list>
                </div>
            </v-col>

            <v-col v-if="$vuetify.breakpoint.mdAndUp">
                <v-img
                    :src="require(`@/assets/projects/${value.img}`)"
                    height="400"
                    width="500"
                    contain
                    class="mx-auto"
                />
            </v-col>
        </v-row>
    </v-sheet>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: () => ({
                name: '',
                type: '',
                description: '',
                technologies: '',
                url: '',
                img: undefined,
            }),
        },
    },
};
</script>

<style lang="scss" scoped>
.link a {
    text-decoration: none;
    color: white;
}

.link a:hover {
    text-decoration: none;
    color: #ffaa00;
}
</style>
